import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Professional.Form.Translations.Acordion.scss'
import { withTranslation } from 'react-i18next'

class TranslationsAcordion extends Component {
  static defaultProps = {
    opened: false,
  }
  static propTypes = {
    name: PropTypes.string.isRequired,
    opened: PropTypes.bool,
  }
  toggleAccordion = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }
  constructor(props) {
    super()
    this.state = {
      isOpen: !!props.opened,
    }
  }
  render() {
    const { language, t } = this.props
    return (
      <>
        <div className={`accordion-translation`} onClick={this.toggleAccordion}>
          <span className="name">{language ? language.name : t('Nueva traducción')}</span>
          <span className={this.state.isOpen ? 'fa fa-chevron-down chevron' : 'fa fa-chevron-up chevron'} />
        </div>
        <div style={this.state.isOpen ? { display: 'block' } : { display: 'none' }}>{this.props.children}</div>
      </>
    )
  }
}
export default withTranslation()(TranslationsAcordion)
